import { useQuery } from "@tanstack/react-query";
import { useBackend, useRegion } from "./useRegion";
import { RecentOrder, RecentOrdersIndeterminate } from "src/types";

export function useAllRecentMRROrders(): RecentOrdersIndeterminate {
    const region = useRegion();
    const backend = useBackend();
    const { status, data, error } = useQuery<RecentOrder[], Error>({
        queryFn: () => backend.get<{ result: RecentOrder[] }>(`/getAllRecentMRROrders`).then((res) => res.data.result),
        //region is put in as a queryKey to prompt a refetch on region change
        queryKey: ["recent-orders", region],
        staleTime: Infinity,
    });

    if (status === "pending") return null;
    if (status === "error") return error;
    else return data;
}
